/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Adjustment_Link_Not_ConfirmedInputs */

const en_shipping_adjustment_link_not_confirmed = /** @type {(inputs: Shipping_Adjustment_Link_Not_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping adjustment created, but payment link generation was not confirmed.`)
};

const es_shipping_adjustment_link_not_confirmed = /** @type {(inputs: Shipping_Adjustment_Link_Not_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El ajuste de envio se creo, pero el link de pago no fue confirmado.`)
};

/**
* | output |
* | --- |
* | "Shipping adjustment created, but payment link generation was not confirmed." |
*
* @param {Shipping_Adjustment_Link_Not_ConfirmedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const shipping_adjustment_link_not_confirmed = /** @type {((inputs?: Shipping_Adjustment_Link_Not_ConfirmedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Adjustment_Link_Not_ConfirmedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_adjustment_link_not_confirmed(inputs)
	return es_shipping_adjustment_link_not_confirmed(inputs)
});